import { useMemo } from "react";
import ChartOption from "../types/instance/ChartOption";
import EChart from "./chart/echarts/EChart";
import { buildCategoryBarOption } from "./chart/echarts/categoryBarOption";

type BarChartProps = {
  uniqueIndex: number;
  chartOption: ChartOption;
  title?: string;
};

const TOP_N = 10;

function BarChart({ uniqueIndex, chartOption, title }: BarChartProps) {
  const option = useMemo(() => {
    const bars = [...chartOption.data]
      .sort((a: any, b: any) => b.y - a.y)
      .slice(0, TOP_N)
      .map((d: any) => ({ name: d.name, value: d.y, color: d.color }));

    return buildCategoryBarOption({ bars, seriesName: chartOption.key });
  }, [chartOption.data, chartOption.key]);

  return (
    <div className="col">
      <div className="card collapsible">
        <div className="card-header">
          <i className="fal fa-chart-bar fa-fw" aria-hidden="true"></i>
          {title ? title : `Top ${chartOption.key.toLowerCase()}`}
          <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
             data-bs-target=".multi-collapse-pie" aria-expanded="false" aria-controls=""></i>
        </div>
        <div id={`collapseChart${uniqueIndex}`} className="card-body collapse show multi-collapse-pie">
          <EChart option={option} height={300}/>
        </div>
      </div>
    </div>
  );
}

export default BarChart;
